import {MembershipBenefitType} from "../../../Model/MembershipBenefit";


export default class MembershipFreeItemService {
    constructor({membership, orders, menuItems}) {
        this.membership = membership
        this.orders = orders
        this.menuItems = menuItems
    }

    getEligibleOrderItem = () => {
        let freeItemsCriteria = [];
        (this.membership.membership_free_items || []).forEach(freeItem => {
            if (freeItem.balance_quantity > 0) {
                let categoryIds = []
                let menuItemIds = []
                // Explicit category id
                if (freeItem.category_id) {
                    categoryIds.push(freeItem.category_id)
                }

                // Category id look up from membership benefit package
                (this.membership.membership_benefits || []).forEach(item => {
                    if (item.id === freeItem.membership_benefit_id) {
                        let detail = item.detail
                        if (detail && detail.type === MembershipBenefitType.FreeItem) {
                            if (detail.category) {
                                if (!Array.isArray(detail.category)) {
                                    categoryIds.push(detail.category)
                                }
                                else {
                                    categoryIds = categoryIds.concat(detail.category)
                                }
                            }
                            if (detail.menu_item_ids) {
                                if (!Array.isArray(detail.menu_item_ids)) {
                                    menuItemIds.push(detail.menu_item_ids)
                                }
                                else {
                                    menuItemIds = menuItemIds.concat(detail.menu_item_ids)
                                }
                            }
                        }
                    }
                })

                freeItemsCriteria.push({
                    // Take note of id that we know to deduct from which free item
                    membership_free_item_id: freeItem.id,
                    category_ids: categoryIds.map(c => parseInt(c)),
                    menu_item_ids: menuItemIds.map(c => parseInt(c)),
                    expire_at: moment(freeItem.expire_at, 'YYYY-MM-DD HH:mm:ss')
                })
            }
        })

        // Sort - Free item that expire soon processed first
        freeItemsCriteria.sort((a,b) => {
            return a.expire_at.diff(b.expire_at)
        })

        let eligibleOrders = this.orders.map(order => {
            let orderItemMenuItem = this.menuItems.find(menuItem => menuItem.id == order.menu_item_id)
            let orderItemCategoryId = orderItemMenuItem.getCategory()?.id
            let freeItemCriteria = freeItemsCriteria.filter(criteria => {
                return criteria.category_ids.includes(parseInt(orderItemCategoryId)) || criteria.menu_item_ids.includes(parseInt(orderItemMenuItem.id))
            })
            if (freeItemCriteria.length > 0) {
                return {
                    membership_free_item_id: freeItemCriteria[0].membership_free_item_id,
                    order
                }
            }
            return false
        }).filter(item => item)
        return eligibleOrders
    }
}